export class NyukyoInfo {
    lifeLineElectricity = "";
    lifeLineGas = "";
    lifeLineWater = "";
    postDialNo = "";
    gomiShushubiUrl = "";
    shokaiHikiotoshibi = "";
    propertyCode = 0;
    orgNyukyokeiyakuNo = 0;
}
